

const initialState = {
    openDialogDetector: false,
    openDialogObject: false,
    openDialogSTL: false,
    openDialogSource: false,
    openDialogArchive: false,
    openDialogWelcome: true,
    indexPreviewCarousel: 0,
    indexArchiveItem: 0,
    energySelectionActive: true,
    activePage: 0,
}



//-----------------------------------------------------------------



const reducer = (state = initialState, action) => {
    switch (action.type) {

        case "INTERACTION:ENERGY-SLECTION-ACTIVE-CHANGE":
            console.log("Change energy selection active");
            return Object.assign({}, state, {
                energySelectionActive: action.value,
            });

        case "DIALOG:DETECTOR-OPEN":
            console.log("Open Detetcor Dialog");
            return Object.assign({}, state, {
                openDialogDetector: true,
            });

        case "DIALOG:DETECTOR-CLOSE":
            console.log("Close Detetcor Dialog");
            return Object.assign({}, state, {
                openDialogDetector: false,
            });

        case "DIALOG:OBJECT-OPEN":
            console.log("Open Object Dialog");
            return Object.assign({}, state, {
                openDialogObject: true,
            });

        case "DIALOG:OBJECT-CLOSE":
            console.log("Close Object Dialog");
            return Object.assign({}, state, {
                openDialogObject: false,
            });

        case "DIALOG:STL-OPEN":
            console.log("Open STL Dialog");
            return Object.assign({}, state, {
                openDialogSTL: true,
            });

        case "DIALOG:STL-CLOSE":
            console.log("Close STL Dialog");
            return Object.assign({}, state, {
                openDialogSTL: false,
            });

        case "DIALOG:SOURCE-OPEN":
            console.log("Open Source Dialog");
            return Object.assign({}, state, {
                openDialogSource: true,
            });

        case "DIALOG:SOURCE-CLOSE":
            console.log("Close Source Dialog");
            return Object.assign({}, state, {
                openDialogSource: false,
            });

        case "DIALOG:WELCOME-OPEN":
            console.log("Open Welcome Dialog");
            return Object.assign({}, state, {
                openDialogWelcome: true,
            });

        case "DIALOG:WELCOME-CLOSE":
            console.log("Close Welcome Dialog");
            return Object.assign({}, state, {
                openDialogWelcome: false,
            });

        case "DIALOG:ARCHIVE-ITEM-OPEN":
            console.log("Open Archive Dialog");
            return Object.assign({}, state, {
                openDialogArchive: true,
                indexArchiveItem: action.value,
            });

        case "DIALOG:ARCHIVE-ITEM-CLOSE":
            console.log("Close Archive Dialog");
            return Object.assign({}, state, {
                openDialogArchive: false,
            });

        case "CAROUSEL:UPDATE-INDEX":
            console.log("Carousel index update");
            return Object.assign({}, state, {
                indexPreviewCarousel: action.value,
            });

        case "PAGE:SET-ACTIVE-PAGE":
            console.log("Carousel index update");
            return Object.assign({}, state, {
                activePage: action.value,
            });

        default:
            return state;
    }
}

export { reducer }